import React, { useCallback, useEffect, useRef, useState } from 'react';
import { AiOutlineArrowDown, AiOutlineArrowUp } from 'react-icons/ai';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import FileSaver from 'file-saver';

import { ReactComponent as CleanIcon } from '../../../../assets/icons/ubr_clean.svg';
import { ReactComponent as DownloadIcon } from '../../../../assets/icons/ubr_download.svg';
import { ReactComponent as FilterIcon } from '../../../../assets/icons/ubr_filter.svg';
import { ReactComponent as SearchIcon } from '../../../../assets/icons/ubr_search.svg';
import {
  Button,
  Input,
  Pagination,
  Select,
  Shimmer,
} from '../../../../components';
import api from '../../../../services/api';
import { statusOptions } from './status';
import {
  ActionsForm,
  Badge,
  Container,
  FooterTable,
  InputGroup,
  LoadingData,
  OrderContainer,
  TableContainer,
} from './styles';

export enum StatusType {
  Default = 'DEFAULT',
  Pendente = 'PENDENTE',
  Processando = 'PROCESSANDO',
  Sucesso = 'SUCESSO',
  Erro = 'ERRO',
}
interface SearchProps {
  cooperativa: string | undefined;
  conta: string | undefined;
  agencia: string | undefined;
  status: StatusType | undefined;
}

// interface DataProps {
//   cooperativa: string;
//   agencia: string;
//   conta: string;
//   dataLogin: string;
//   dataPrimeiraOperacao: string;
//   dataUltimaOperacao: string;
//   status: StatusType;
//   tipoValidacao: string;
//   dataUltimaHomologacao: string;
// }

const RelatorioSintetico: React.FC = () => {
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [itemsPerPage, setitemsPerPage] = useState<number>(5);
  const formRef = useRef<FormHandles | null>(null);
  let selectedStatus = useRef<any>();

  const [order, setOrder] = useState<boolean>();

  const [filter, setFilter] = useState<{
    agencia: string | null;
    conta: string | null;
    status: string | null;
    cooperativa: string | null;
    paginacao: {
      direcao: string;
      numeroPagina: number;
      tamanhoPagina: number;
    };
    produto: string;
  }>({
    cooperativa: data.cooperativa ? data.cooperativa : null,
    agencia: data.agencia ? data.agencia : null,
    conta: data.conta ? data.conta : null,
    status: data.status ? data.status : null,
    paginacao: {
      direcao: !order ? 'ASC' : 'DESC',
      numeroPagina: currentPage,
      tamanhoPagina: itemsPerPage,
    },
    produto: 'PAGAMENTOS',
  });

  function formatDate(data: string) {
    if (!data) {
      return 'N/D';
    }
    let dateLocal = new Date(data);
    return (
      dateLocal.toLocaleDateString() + ' ' + dateLocal.toLocaleTimeString()
    );
  }

  // Renderizar a tabela

  const loadingTable = () => {
    return (
      <tr>
        <td>
          <p
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </p>
        </td>
        <td>
          <p
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </p>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
      </tr>
    );
  };

  const renderData = () => {
    return (
      <TableContainer>
        <table id="tableData">
          <thead>
            <tr>
              <th style={{ width: '160px' }}>
                <OrderContainer>
                  Cooperativa
                  {order ? (
                    <button onClick={() => setOrder(false)}>
                      <AiOutlineArrowUp />
                    </button>
                  ) : (
                    <button onClick={() => setOrder(true)}>
                      <AiOutlineArrowDown />
                    </button>
                  )}
                </OrderContainer>
              </th>
              <th style={{ width: '140px' }}>Agência</th>
              <th style={{ width: '140px' }}>Conta</th>

              <th style={{ width: '140px' }}>
                Data do Primeiro Login cooperado
              </th>
              <th style={{ width: '140px' }}>Data do Inicio da Operação</th>
              <th style={{ width: '140px' }}>Ultima Data Operação</th>
              <th style={{ width: '140px' }}>Data da Ultima Homologação</th>
              <th style={{ width: '140px' }}>Ultimo Status do Processo</th>
            </tr>
          </thead>
          {isLoading ? (
            <tbody>
              {loadingTable()}
              {loadingTable()}
              {loadingTable()}
            </tbody>
          ) : !data.content!?.length ? (
            <LoadingData> Sem dados para exibir... </LoadingData>
          ) : (
            <tbody>
              {data!?.content!?.map((todo: any, index: number) => (
                <tr key={index}>
                  <td data-column="Cooperativa">{todo.cooperativa}</td>
                  <td data-column="Agencia">{todo.agencia}</td>
                  <td data-column="Conta">{todo.conta}</td>

                  <td data-column="Data do Primeiro Login cooperado">
                    {formatDate(todo.dataLogin)}
                  </td>
                  <td data-column="Data do inicio da operação">
                    {formatDate(todo.dataPrimeiraOperacao)}
                  </td>
                  <td data-column="Ultima Data da Operacao">
                    {formatDate(todo.dataUltimaOperacao)}
                  </td>
                  <td data-column="Data da Ultima Homologação">
                    {formatDate(todo.dataUltimaHomologacao)}
                  </td>
                  <td data-column="Ultimo Status do Processo">
                    {!!todo.status ? (
                      <Badge type={todo.status}>{todo.status}</Badge>
                    ) : (
                      '-'
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </TableContainer>
    );
  };

  // Data

  const fetchData = useCallback(
    async (search: any) => {
      formRef.current?.setErrors({});
      setIsLoading(true);
      try {
        const response = await api.post(
          '/pagamento/relatorios/sintetico',
          search,
        );

        setIsLoading(false);
        setData(response.data);
      } catch (e) {
        console.error(e);
      }
    },
    [filter, itemsPerPage, currentPage, order],
  );

  useEffect(() => {
    fetchData({
      ...filter,
      paginacao: {
        direcao: !order ? 'ASC' : 'DESC',
        numeroPagina: currentPage,
        tamanhoPagina: itemsPerPage,
      },
    });
  }, [currentPage, itemsPerPage, order]);

  // const limits = useCallback(e => {
  //   setitemsPerPage(e.value);
  //   setCurrentPage(1);
  // }, []);

  const handleFilter = useCallback(
    async (data: SearchProps) => {
      try {
        setFilter({
          cooperativa: data.cooperativa ? data.cooperativa : null,
          agencia: data.agencia ? data.agencia : null,
          conta: data.conta ? data.conta : null,
          status: data.status ? data.status : null,
          paginacao: {
            direcao: !order ? 'ASC' : 'DESC',
            numeroPagina: currentPage,
            tamanhoPagina: itemsPerPage,
          },
          produto: 'PAGAMENTOS',
        });
        fetchData({
          cooperativa: data.cooperativa ? data.cooperativa : null,
          agencia: data.agencia ? data.agencia : null,
          conta: data.conta ? data.conta : null,
          status: data.status ? data.status : null,
          paginacao: {
            direcao: !order ? 'ASC' : 'DESC',
            numeroPagina: currentPage,
            tamanhoPagina: itemsPerPage,
          },
          produto: 'PAGAMENTOS',
        });
        setIsLoading(false);
      } catch (err) {}
    },
    [filter],
  );

  // Sort Data

  // const sortList = (relatory: DataProps[]): DataProps[] => {
  //   let orderList = relatory.sort(function (a, b): any {
  //     if (a.cooperativa.toUpperCase() < b.cooperativa.toUpperCase()) return -1;
  //     if (a.cooperativa.toUpperCase() > b.cooperativa.toUpperCase()) return 1;
  //     return 0;
  //   });
  //   if (sortAscending.current) {
  //     return orderList;
  //   }
  //   return orderList.reverse();
  // };

  // const toggleListOrder = () => {
  //   sortAscending.current = !sortAscending.current;
  //   const sortedList = sortList(data);
  //   setData([...sortedList]);
  // };

  const onClear = () => {
    formRef.current?.reset();

    const select = formRef!.current!.getFieldRef('status');
    select.select.clearValue();

    fetchData({
      cooperativa: null,
      agencia: null,
      conta: null,
      status: null,
      paginacao: {
        direcao: !order ? 'ASC' : 'DESC',
        numeroPagina: 0,
        tamanhoPagina: itemsPerPage,
      },
      produto: 'PAGAMENTOS',
    });
  };

  const relatoryDownload = async () => {
    const response = await api.post(
      'pagamento/relatorios/sintetico/completo',
      filter,
      {
        responseType: 'arraybuffer',
      },
    );

    const url = URL.createObjectURL(
      new Blob(['\ufeff', response.data], {
        type: 'text/csv;charset=utf-8',
      }),
    );

    FileSaver.saveAs(
      url,
      'relatório-analítico_' + new Date().getTime() + '.csv',
    );
  };

  // const options = [
  //   { value: 5, label: 5 },
  //   { value: 10, label: 10 },
  //   { value: 20, label: 20 },
  // ];

  return (
    <Container>
      <Form className="form-container" ref={formRef} onSubmit={handleFilter}>
        <FilterIcon width={28} />
        <InputGroup>
          <Input
            name="cooperativa"
            label="Cooperativa"
            type="text"
            mask={'coop'}
            placeholder="Ex.: 0000"
          />
          <Input
            name="agencia"
            label="Agencia"
            type="text"
            mask={'coop'}
            placeholder="Ex.: 0000"
          />
          <Input
            name="conta"
            label="Conta"
            type="text"
            mask={'conta'}
            placeholder="Ex.: 00000-0"
          />

          <div className="select-field">
            <Select
              name={'status'}
              isMulti={false}
              options={statusOptions}
              onChange={option => (selectedStatus.current = option.value)}
              placeholder="Selecione"
              label="Status"
              loading={!statusOptions.length ? true : false}
            />
          </div>
        </InputGroup>
        <ActionsForm>
          <div>
            <Button
              variant="solid-icon"
              type={'submit'}
              style={{ marginRight: '1rem' }}
              tooltipText={'Pesquisar'}
            >
              <SearchIcon style={{ width: '26px' }} />
            </Button>
            <Button
              variant="solid-icon"
              type={'reset'}
              onClick={onClear}
              tooltipText={'Limpar Campos'}
            >
              <CleanIcon style={{ width: '26px' }} />
            </Button>
          </div>

          <Button
            onClick={() => relatoryDownload()}
            variant={'solid-icon'}
            tooltipText={'Baixar Relatório'}
            style={{ width: '24px' }}
          >
            <DownloadIcon />
          </Button>
        </ActionsForm>
      </Form>
      {renderData()}
      <FooterTable>
        <Pagination
          pageCount={data.totalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={data.size}
          forcePage={currentPage}
          onPageChange={(pageNumber: any) => {
            setCurrentPage(pageNumber.selected);
          }}
          onPageSize={(pageSize: any) => {
            setCurrentPage(0);
            setitemsPerPage(pageSize.value);
          }}
        />
      </FooterTable>
    </Container>
  );
};

export default RelatorioSintetico;
